export default __webpack_public_path__ + "static/media/link.fd046b8e.svg";